import { useCallback } from 'react';
import { useEventListener } from 'usehooks-ts';
/**
 * Catches `onKeyDown` **window** based event and if the `key` is *F* and *Ctrl* key is being pressed, then `callback`
 * function is called.
 */
const useOverrideWindowFindShortcut = (callback) => {
    const onWindowKeyDown = useCallback((event) => {
        // TODO: to delete later
        // if (document.activeElement !== document.body) {
        // 	return;
        // }
        if (event.code === 'KeyF' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            callback();
        }
    }, [callback]);
    // Window based event
    useEventListener('keydown', onWindowKeyDown);
};
export { useOverrideWindowFindShortcut };
